module.exports = __webpack_public_path__ + "static/media/PRISM_6500.cbbf46f6.jpg";